<template>
  <div v-if="!loading" class="pc-mode">
    <header id="header">
      <div class="container">
        <div class="title">
          <a href="https://www.westjr.co.jp/" target="_blank"><img id="logo" src="../../assets/images/jr_logo.svg" alt="JR西日本旅客鉄道株式会社" width="71"></a>
          <router-link id="delay" :to="{ name: 'SiteTop' }">遅延証明書</router-link>
        </div>
      </div>
    </header>
    <div class="container">
      <article>
        <div class="message-container">
          <div class="message">
            システムメンテナンス中のため、ただいまサービスを利用できません。<br/>
            ご不便をおかけいたしますが、ご理解いただきますようお願いいたします。
          </div>
        </div>
      </article>
    </div>
    <site-footer/>
  </div>
</template>

<script>
import SiteHeader from '@/components/pc/SiteHeader'
import SiteFooter from '@/components/pc/SiteFooter'
import { mapState } from 'vuex'
export default {
  name: 'Maintenance',
  components: {
    SiteHeader,
    SiteFooter
  },
  created () {
    this.$store.commit('loading/setStatus', false)
  },
  computed: {
    ...mapState('loading', {
      loading: state => state.status
    })
  }
}
</script>

<style lang="scss" scoped>
@import '../../css/variables';
a {
  &#delay {
    margin-left: 23px;
    font-weight: 600;
  }
}
header {
  line-height: 90px;
  border-bottom: 1px solid #e6e6e6 !important;
  .title {
    color: $primary;
  }
}
#delay {
  text-decoration: none;
  font-size: 23px;
}
.message-container {
  display: table;
  width: 100%;
  .message {
    height: 500px;
    font-weight: 600;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/Maintenance.vue